import React from 'react';
import { Container } from './styles';
import { SyncOutlined } from '@ant-design/icons';
import { useSelector } from 'react-redux';
import { ApplicationState } from '../../store';
import { Tooltip } from 'antd';

const Refresh: React.FC<{ loadRequest: any }> = ({ loadRequest }) => {
  const inscricaoAtiva = useSelector((state: ApplicationState) => state.auth.inscricaoAtiva);
  const ref: React.MutableRefObject<null | any> = React.useRef(null);
  const [loading, setLoading] = React.useState(false);

  React.useEffect(() => {
    if (loading) {
      ref?.current?.classList?.add('rotate');
      ref?.current?.classList?.remove('icon');
      setTimeout(() => {
        ref?.current?.classList?.remove('rotate');
        ref?.current?.classList?.add('icon');
      }, 1000);
    }

    return () => {
      setLoading(false);
    };
  }, [loading]);

  return (
    <Tooltip
      title={inscricaoAtiva?.length > 0 ? '' : 'Selecione o CD e parceiro'}
      placement="bottom"
    >
      <Container
        onClick={() => inscricaoAtiva?.length > 0 && loadRequest() && setLoading(true)}
        aria-disabled={inscricaoAtiva.length > 0 ? false : true}
      >
        <SyncOutlined className="icon" ref={ref} />
        <div className="themeDashboard" style={{ background: 'none' }}>
          Atualizar
        </div>
      </Container>
    </Tooltip>
  );
};

export default Refresh;
